<template>
  <div class="headTop">
    <el-card shadow="never" class="box-card">
      <div slot="header" class="clearfix">
        <el-button size="small" style="margin-left: 5px" icon="el-icon-view" type="default"
          @click="onTOInvoice">开票申请</el-button>
      </div>
      <div class="text item">
        <el-row>
          <el-col :span="24">
            <el-table :data="dataDictList" border height="360" ref="table" highlight-current-row
              @row-click="onTableRowClick" @row-dblclick="onTableRowDblClick" style="width: 100%">
              <el-table-column label="序号" type="index" width="50">
              </el-table-column>
              <!-- <el-table-column
                sortable
                prop="DealNo"
                label="交易编号"
              ></el-table-column> -->
              <el-table-column sortable prop="DealTime" label="交易时间"></el-table-column>
              <el-table-column sortable prop="ChannelName" label="充值渠道"></el-table-column>
              <el-table-column sortable prop="ChannelNo" label="交易流水号"></el-table-column>
              <el-table-column sortable prop="RechargeAmount" label="充值金额"></el-table-column>
              <el-table-column sortable prop="ActualRechargeAmount" label="实际充值金额"></el-table-column>
              <el-table-column sortable prop="AuditStatus" label="审核结果">
                <template slot-scope="scope">
                  {{ AuditStatusFormat(scope.row.AuditStatus)}}
                </template>
              </el-table-column>
              <el-table-column sortable prop="AuditRemark" label="审核备注"></el-table-column>
            </el-table>
            <el-row type="flex" justify="end" align="middle" style="height: 40px">
              <el-pagination @size-change="handlePaginationSizeChange" @current-change="handlePaginationCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[20, 40, 60, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
              </el-pagination>
            </el-row>
          </el-col>
        </el-row>
        <div>
          <el-dialog
            title="充值详情"
            class="Dialog"
            ref="NewsDialong"
            :visible.sync="dialogVisible"
            :show-close="false"
            :close-on-click-modal="false"
            width="40%"
          >
            <EditData
              ref="fromAdd"
              :dataForm="formData"
              :inPutShow="inPutShow"
            ></EditData>
            <span slot="footer" class="dialog-footer">
              <el-button @click="onCancel">关  闭</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { GetList, Edit, Add, Del ,OrderInvoiceEdit} from '@/api/general-api'
import EditData from '@/components/FormData/Money/myRechargeDetail/index.vue'
import ToInvoice from './ToInvoice.vue'
import Vue from "vue"
export default {
  components: {
    EditData
  },
  data() {
    return {
      dataDictList: [],
      currentRow: {},
      searchParam: [],
      pagination: {
        pageSize: 20,
        currentPage: 1,
        total: 0,
        orderField: 'ID',
        orderType: 'ascend'
      },
      // 编辑弹窗的开关
      dialogVisible: false,
      // 编辑或者查看的时候里面内容是否能输入
      inPutShow: false,
      // 传给表单的数据
      formData: {},
      lilili: {
        //  Shop_RechargeRecord  充值记录
        DealNo: '交易编号',
        DealTime: '交易时间',
        ChannelName: '渠道名称',
        ChannelNo: '交易渠道流水号',
        RechargeAmount: '充值金额',
        IsDeleted: null,
      }
    }
  },
  mounted() {
    this.handleSearching()
  },
  methods: {
    //开票申请
    onTOInvoice(){
      if (!this.currentRow) {
        return this.$message({
          message: '请选中需要申请行',
          type: 'error',
          offset: 150
        })
      }
     var RechargeRecords=[];
     var row={};
     row.InvoicePrice=this.currentRow.RechargeAmount;
     row.OrderInfo="充值";
     row.ChannelName=this.currentRow.ChannelName;
     row.aTime=this.currentRow.CreateTime;
     RechargeRecords.push(row)
      this.onOpenToInvoiceDialog(RechargeRecords)
    },
    onOpenToInvoiceDialog(RechargeRecords) {
      console.log(RechargeRecords)
      const GirConstructor = Vue.extend(ToInvoice);
      const nodeObj = new GirConstructor();
      nodeObj.$mount(document.createElement("div"));
      document.body.appendChild(nodeObj.$el);
     nodeObj.Options({ RechargeRecords: RechargeRecords });
      nodeObj.Open((shopList, close) => {
        console.log(shopList);
        let postParam = {
          data: shopList
        }
        OrderInvoiceEdit(postParam).then(res => {
          console.log(res);
          if (!res.success) {
            return this.$message.error('申请开票失败' + res.msg)
          }
          this.$message.success("申请开票成功！")
          close()
        })
      });
    },

    AuditStatusFormat(val) {
      let value = ''
      if (val == 1) {
        value = '审核通过'
      } else if (val == 0) {
        value = '待审核'
      } else if (val == -1) {
        value = '拒绝'
      }
      return value
    },
    async handleSearching() {
      const params = [...this.searchParam];
      params.push({
        SqlField: "IsDeleted",
        pattern: "equal",
        value: "false",
      });
      const queryParam = {
        Name: 'RechargeRecord',
        searchEntity: JSON.stringify(params),
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      }
      this.currentRow = null
      await GetList(queryParam).then((res) => {
        if (res.success) {
          this.dataDictList = res.data.rows
          this.pagination.total = res.data.total
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // --分页器每页显示数据改变事件
    handlePaginationSizeChange(val) {
      this.pagination.pageSize = val
      this.handleSearching()
    },
    // --分页器当前页改变事件
    handlePaginationCurrentChange(val) {
      this.pagination.currentPage = val
      this.handleSearching()
    },
    onAdd() {
      this.inPutShow = false
      this.judgment = 'Add'
      this.formData = {}
      this.dialogVisible = true
    },
    // 编辑
    onEditRole() {
      if (!this.currentRow) {
        return this.$message({
          message: '请选中需要查看的行或者双击该行',
          type: 'error',
          offset: 150
        })
      }
      this.inPutShow = false
      this.formData = JSON.parse(
        JSON.stringify({
          ...this.currentRow
        })
      )
      this.dialogVisible = true
    },
    // 点击某一行
    onTableRowClick(row) {
      this.currentRow = {
        ...row
      }
    },
    // 双击某一行
    onTableRowDblClick(row) {
      this.formData = {
        ...row
      }
      this.inPutShow = true
      this.dialogVisible = true
    },
    // 弹窗的两个点击
    onCancel() {
      this.formData = {}
      this.inPutShow = false
      this.currentRow = null
      this.addressArray = []

      this.$refs.table.setCurrentRow()
      this.$refs.fromAdd.$refs.form.resetFields()
      this.dialogVisible = false
    },
  }
}
</script>
<style scoped lang="scss"></style>